import { useContext } from 'react';
import { APIContext } from '../../Contexts/APIContext';
import InputLabel from '@mui/material/InputLabel';
import Grid from '@mui/material/Grid2';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { FormContainer, useForm } from 'react-hook-form-mui';
import Card from '../../Utilities/Card';
import IdentityContainer from '../../Utilities/IdentityContainer';
import ValidatedTextField from '../../Utilities/Forms/ValidatedTextField';
import UserProfileViewModel from './ViewModels/UserProfileViewModel';
import React from 'react';

export default function UpdateUserForm() {
    const { get } = React.useContext(APIContext);

    const formContext = useForm<UserProfileViewModel>({
        defaultValues: new UserProfileViewModel(),
    });

    const { post, loading } = useContext(APIContext);

    const userId  = 'a';

    const { reset } = formContext;

    React.useEffect(() => {
        if (userId && userId.length > 0) {
            getData();
        }
    }, [userId]);

    const getData = async () => {
        await get("User", `GetUserDetails?id=${userId}`, reset);
    }


    const update = async (form: UserProfileViewModel) => {
        await post('User', 'CreateEditUser', form);
    };

    return (
        <IdentityContainer sx={{ mt: 5 }} direction="column" justifyContent="space-between">
            <Card variant="outlined">
                <FormContainer
                    formContext={formContext}
                    onSuccess={update}
                >
                    <Box
                        component="img"
                        sx={{
                            height: 50,
                            width: 50,
                        }}
                        alt="TRICS logo."
                        src={process.env.PUBLIC_URL + '/trics-logo.png'}
                    />
                    <Typography
                        component="h1"
                        variant="h4"
                        sx={{ width: '100%', fontSize: 'clamp(2rem, 10vw, 2.15rem)' }}
                    >
                        Register
                    </Typography>
                    <Grid container spacing={2}>
                        <Grid size={{ xs: 12 }}>
                            <InputLabel shrink>First Name</InputLabel>
                            <ValidatedTextField name="firstName" />
                        </Grid>
                        <Grid size={{ xs: 12 }}>
                            <InputLabel shrink>Surname</InputLabel>
                            <ValidatedTextField name="lastName" />
                        </Grid>
                        <Grid size={{ xs: 12 }}>
                            <InputLabel shrink>Email</InputLabel>
                            <ValidatedTextField name="email" />
                        </Grid>
                        <Grid size={{ xs: 12 }}>
                            <Button type="submit" disabled={loading} fullWidth variant="contained">Update</Button>
                        </Grid>
                    </Grid>
                </FormContainer>
            </Card>
        </IdentityContainer>
    );
}
